import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body-2" }

import { computed, PropType } from 'vue'
import parseISO from 'date-fns/parseISO'
import { formatIntlDateOnly } from '@/utils/formatters'
import differenceInDays from 'date-fns/differenceInDays'
import { StringDate, StringDateTime } from '@/models/shared.model'
import { Guests } from '@/models/public/service.model'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'HousingSelectionOverview',
  props: {
  start: {
    type: [Date, String, null] as PropType<
      Date | StringDateTime | StringDate | null
    >,
    required: true,
  },
  end: {
    type: [Date, String, null] as PropType<
      Date | StringDateTime | StringDate | null
    >,
    required: true,
  },
  guests: {
    type: Array as PropType<Guests[]>,
    required: true,
  },
  /**
   * Use it for calculating total number of all additional services.
   * Supports both the number directly or object where values are quantities
   */
  additionalServices: {
    type: [Object, Number] as PropType<Record<string, number> | number>,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props



const i18n = useI18n()

const startDate = computed<Date | null>(() => {
  if (props.start instanceof Date) {
    return props.start
  }
  return parseISO(props.start)
})

const endDate = computed<Date | null>(() => {
  if (props.end instanceof Date) {
    return props.end
  }
  return parseISO(props.end)
})

const startFormatted = computed<string>(() => {
  if (startDate.value === null) {
    return ''
  }
  return formatIntlDateOnly(startDate.value)
})

const nights = computed<number>(() => {
  if (startDate.value === null || endDate.value === null) {
    return 0
  }
  return differenceInDays(endDate.value, startDate.value)
})

const rooms = computed<number>(() => {
  return props.guests.reduce((occupiedRooms: number, room: Guests) => {
    if (room.adults > 0 || room.children > 0) {
      return occupiedRooms + 1
    }
    return occupiedRooms
  }, 0)
})

const groupSize = computed<number>(() => {
  return props.guests.reduce((totalGuests: number, room: Guests) => {
    return totalGuests + room.adults + room.children
  }, 0)
})

/**
 * Total quantity of all selected additional services
 */
const additionalServicesQuantity = computed<number>(() => {
  if (typeof props.additionalServices === 'number') {
    return props.additionalServices
  }
  return Object.values(props.additionalServices).reduce(
    (total, quantity) => total + quantity,
    0,
  )
})

const additionalServicesFormatted = computed<string>(() => {
  if (additionalServicesQuantity.value === 0) {
    return ''
  }
  return (
    ', ' +
    i18n.t(
      'plurals.numberOfAdditionalServices',
      additionalServicesQuantity.value,
    )
  )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(startFormatted)) + ", " + _toDisplayString(_ctx.$t('plurals.numberOfNights', _unref(nights))) + ", " + _toDisplayString(_ctx.$t('plurals.numberOfGuests', _unref(groupSize))) + _toDisplayString(_unref(rooms) === 1 ? '' : `, ${_ctx.$t('plurals.numberOfRooms', _unref(rooms))}`) + _toDisplayString(_unref(additionalServicesFormatted)), 1))
}
}

})